const Menus = [
    { Text: "關於我們",Href:"/about" },
    { Text: "服務項目",Href:"/"},
    { Text: "AI 應用系統服務",Href:"/productintro" },
    { Text: "AI 進銷存管理系統",Href:"/ai-inventory" },
    { Text: "招募培訓管理",Href:"/HRTraining" },
    { Text: "成功案例",Href:"/successcase"},
    { Text: "聯絡我們",Href:"/contactus"}
];

export default Menus;